export const state = () => ({
  loginToken: null,
  username: 'test',
  userId: null
})

export const getters = {
  loginTokenGetter: state => state.loginToken || '',
  usernameGetter: state => state.username || '',
  userIdGetter: state => state.userId || ''
}

export const mutations = {
  loginTokenSetter (state, loginToken) {
    state.loginToken = loginToken
  },
  usernameSetter (state, username) {
    state.username = username
  },
  userIdSetter (state, id) {
    state.userId = id
  }
}

export const actions = {
  setToken ({ commit, getters }, loginToken) {
    commit('loginTokenSetter', loginToken)
    window.localStorage.setItem('token', loginToken)
  },
  logout ({ commit, getters }) {
    commit('loginTokenSetter', '')
    commit('usernameSetter', '')
    commit('userIdSetter', '')
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('username')
    window.localStorage.removeItem('userId')
  },
  setUsername ({ commit, getters }, username) {
    commit('usernameSetter', username)
    window.localStorage.setItem('username', username)
  },
  setUserId ({ commit, getters }, id) {
    commit('userIdSetter', id)
    window.localStorage.setItem('userId', id)
  },
  checkToken ({ commit, getters }) {
    const token = window.localStorage.getItem('token')
    const username = window.localStorage.getItem('username')
    const userId = window.localStorage.getItem('userId')
    if (token) {
      commit('loginTokenSetter', token)
      commit('usernameSetter', username)
      commit('userIdSetter', userId)
    }
  }
}
